<script setup lang="ts">
import SvgIcon from "~/components/Common/SvgIcon.vue";
import { CopilotActionVariantEnum } from "~/utils/enums/copilot/chat.enums";
import type { ICopilotAction, ICopilotActions } from "~/utils/interfaces/copilot-interfaces";

defineProps<{
  actions: ICopilotActions;
  disabled?: boolean;
}>();

const emit = defineEmits<{
  pick: [action: ICopilotAction];
}>();
</script>

<template>
  <div class="flex flex-col gap-2">
    <span v-if="actions.intro" class="body_regular text-secondary-color">{{ actions.intro }}</span>

    <div class="flex flex-wrap gap-2">
      <button
        v-for="action of actions.items"
        :key="action.actionId"
        type="button"
        class="flex items-center gap-2 rounded-full border px-3 py-1 body_regular transition-colors disabled:cursor-not-allowed disabled:opacity-50"
        :class="
          action.variant === CopilotActionVariantEnum.PRIMARY
            ? 'border-primary-blue-color bg-light-blue-color text-blue-dark hover:bg-primary-blue-color hover:text-light-color'
            : 'border-stroke-color bg-light-color text-primary-color hover:border-primary-blue-color hover:text-primary-blue-color'
        "
        :disabled="disabled"
        @click="emit('pick', action)"
      >
        <SvgIcon v-if="action.icon" :name="action.icon" class="h-[14px] w-[14px] shrink-0" />
        {{ action.label }}
      </button>
    </div>
  </div>
</template>
